export default {
  countries: state => state.countries,
  country: state => country_name => state.countries.find(item => item.name.toLowerCase() === country_name.toLowerCase()),
  sort: state => state.sort,
  more: state => state.more,
  loading: state => state.loading,
  total: state => state.total,
};
